import "@/App.css";
import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import LandingPage from "@/pages/LandingPage";
import { Toaster } from "@/components/ui/sonner";

/**
 * Kampanya yüzü yalnızca kök sayfa.
 * Oturum, ihale oluşturma vb. tamamı `/var/www/demaxtore/demaxtore-main/frontend`
 * (Next) → `/panel/...`
 */
export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
        </Routes>
        <Toaster position="top-right" />
      </BrowserRouter>
    </div>
  );
}
